import * as React from "react";
const SvgAgentItemsIcon = ({ color }) => (
  <svg width={23} height={22} fill="none">
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m15.5 11-4-4m0 0-4 4m4-4v9.2c0 1.39 0 2.086.55 2.865.366.517 1.42 1.155 2.047 1.24.945.128 1.304-.059 2.022-.433A9.999 9.999 0 0 0 21.5 11c0-5.523-4.477-10-10-10s-10 4.477-10 10a9.996 9.996 0 0 0 5 8.662"
    />
  </svg>
);
export default SvgAgentItemsIcon;
